<template>
  <div :class="[$style.wrapper, inactive && $style.inactive, error && $style.error]" ref="wrapper">
    <transition-group name="button-fade">
      <div :class="$style.message" v-for="message in messages" :key="message">
        {{ message }}
      </div>
    </transition-group>
  </div>
</template>
<script>
const TIMEOUT = 400

export default {
  name: 'Card',
  props: {
    dialog: Array,
    delay: Boolean,
    inactive: Boolean,
    error: Boolean,
  },
  data() {
    return {
      messages: [],
    }
  },
  watch: {
    dialog() {
      this.messages = []
      this.startMessages()
    },
  },
  methods: {
    startMessages() {
      const {
        dialog, delay, $refs,
      } = this

      dialog.forEach((text, index) => {
        setTimeout(() => {
          this.messages.push(text)
          setTimeout(() => { $refs.wrapper.scrollTop = $refs.wrapper.scrollHeight }, 0)
        }, TIMEOUT * (index + 1) + (delay ? TIMEOUT / 2 : 0))
      })
    },
  },
  mounted() {
    this.startMessages()
  },
}
</script>
<style lang="scss" src="./Card.scss" module></style>
